module.exports = __webpack_public_path__ + "img/quest.ff8ffcc5.svg";